export default __webpack_public_path__ + "static/Gaggenau-08-Bold-75f35a84e5f6fba79f26253bd1123186.woff";